import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=d4222d66&"
import script from "./NotesList.vue?vue&type=script&lang=js&"
export * from "./NotesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports